<script>
  import { afterUpdate } from "svelte";

  afterUpdate(() => addPrefetch());

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  import { Navigate, navigateTo } from "svelte-router-spa";
  export let currentRoute;
  var word = {};
  word.title = currentRoute.namedParams.title;
  word.ορισμός = "";
  var loading = true;
  var reallyDelete = false;

  fetch(`/l/${word.title}`)
    .then(data => data.json())
    .then(data => {
      if (!data.title) navigateTo("/");

      word = data;
      loading = false;
    });

  function saveWord() {
    clearTimeout(window.throttleSaveWord);
    window.throttleSaveWord = setTimeout(
      () =>
        fetch(`/l/${word.title}`, {
          method: "PUT",
          body: JSON.stringify(word)
        }),
      800
    );
  }

  function deleteWord() {
    if (!reallyDelete) {
      document.querySelector("#reallyDelete").style.display = "block";
    }

    if (reallyDelete) {
      fetch(`/l/${word.title}`, {
        method: "DELETE"
      });
      setTimeout(() => navigateTo("/"), 0);
    }
  }

  function deleteConfirm(flag) {
    if (!flag) document.querySelector("#reallyDelete").style.display = "none";
    else {
      reallyDelete = true;
      deleteWord();
    }
  }
</script>

<style>
  .selection {
    margin-top: 1em;
  }
</style>

{#if loading}
  Φορτώνει...
{:else}
  <h1>{word.title}</h1>

  <div class="selection">
    <b>Ορισμός:</b>
    <p
      contenteditable
      bind:textContent={word.ορισμός}
      on:keyup={() => saveWord()}>
      {word.ορισμός}
    </p>
  </div>

  <div class="selection">
    <b>Γλώσσα:</b>
    <select
      class="form-control"
      bind:value={word.γλώσσα}
      on:change={() => saveWord()}>
      <option value="undefined">--</option>
      <option value="Αρχαία Ελληνική">Αρχαία Ελληνική</option>
      <option value="Μεσαιωνική Ελληνική">Μεσαιωνική Ελληνική</option>
      <option value="Λατινική">Λατινική</option>
    </select>
  </div>

  <div class="selection">
    <b>Μέρος Του Λόγου:</b>
    <select
      class="form-control"
      bind:value={word.μέροςΤουΛόγου}
      on:change={() => saveWord()}>
      <option value="undefined">--</option>
      <option value="Αντωνυμία">Αντωνυμία</option>
      <option value="Αντωνυμίας μορφή">Αντωνυμίας μορφή</option>
      <option value="Απαρέμφατο">Απαρέμφατο</option>
      <option value="Άρθρο">Άρθρο</option>
      <option value="Άρθρου μορφή">Άρθρου μορφή</option>
      <option value="Αριθμητικό">Αριθμητικό</option>
      <option value="Αριθμητικού μορφή">Αριθμητικού μορφή</option>
      <option value="Έκφραση">Έκφραση</option>
      <option value="Επίθετο">Επίθετο</option>
      <option value="Επιθέτου μορφή">Επιθέτου μορφή</option>
      <option value="Επίθημα">Επίθημα</option>
      <option value="Επίρρημα">Επίρρημα</option>
      <option value="Επιφώνημα">Επιφώνημα</option>
      <option value="Κύριο όνομα">Κύριο όνομα</option>
      <option value="Κύριου ονόματος μορφή">Κύριου ονόματος μορφή</option>
      <option value="Μετοχή">Μετοχή</option>
      <option value="Μετοχής μορφή">Μετοχής μορφή</option>
      <option value="Μόριο">Μόριο</option>
      <option value="Ουσιαστικό">Ουσιαστικό</option>
      <option value="Ουσιαστικού μορφή">Ουσιαστικού μορφή</option>
      <option value="Πολυλεκτικός όρος">Πολυλεκτικός όρος</option>
      <option value="Πρόθεση">Πρόθεση</option>
      <option value="Πρόθημα">Πρόθημα</option>
      <option value="Ρήμα">Ρήμα</option>
      <option value="Ρήματος μορφή">Ρήματος μορφή</option>
      <option value="Σύνδεσμος">Σύνδεσμος</option>
      <option value="Συντομογραφία">Συντομογραφία</option>
      <option value="Χαρακτήρας">Χαρακτήρας</option>
    </select>
  </div>

  <div class="selection">
    <b>Γένος:</b>
    <select
      class="form-control"
      bind:value={word.γένος}
      on:change={() => saveWord()}>
      <option value="undefined">--</option>
      <option value="Αρσενικό">Αρσενικό</option>
      <option value="Θηλυκό">Θηλυκό</option>
      <option value="Ουδέτερο">Ουδέτερο</option>
    </select>
  </div>

  <div class="selection">
    <b>Παρατηρήσεις:</b>
    <p
      contenteditable
      bind:textContent={word.παρατηρήσεις}
      on:keyup={() => saveWord()}>
      {word.παρατηρήσεις}
    </p>
  </div>

  <br />
  <Navigate to="/">
    <button type="button" class="btn btn-primary" data-prefetch="/l">
      Πίσω
    </button>
  </Navigate>
  <input
    type="button"
    class="btn btn-danger"
    on:click={() => deleteWord()}
    value="Διαγραφή" />

  {#if !reallyDelete}
    <div id="reallyDelete" class="reallyDelete" style="display:none;">
      <br />
      Σίγουρα θέλεις να την διαγράψεις;
      <input
        type="button"
        class="btn btn-danger btn-sm"
        value="Ναι"
        on:click={() => deleteConfirm(true)} />
      <input
        type="button"
        class="btn btn-secondary btn-sm"
        value="Όχι"
        on:click={() => deleteConfirm(false)} />
    </div>
  {/if}
{/if}
